module.exports = __webpack_public_path__ + "media/images/mmotrade_logo-c0547fc37e03d7e690500fdb56c5d977.png";